import React from "react";
import "./DataNotFound.scss";
const DataNotFound = ({ message = "No Data Available" }) => {
  return (
    <div className="no-data">
      <div>
      <div className="no-data-icon">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          style={{ width: "50px", height: "50px", color: "#ccc" }}
        >
          <path
            fill="currentColor"
            d="M11 2a9 9 0 1 1-9 9 9 9 0 0 1 9-9Zm0 2a7 7 0 1 0 7 7 7 7 0 0 0-7-7ZM21.71 20.29l-5-5a1 1 0 0 0-1.42 1.42l5 5a1 1 0 0 0 1.42-1.42Z"
          />
          <line
            x1="4"
            y1="20"
            x2="20"
            y2="4"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
          />
        </svg>
      </div>
      <p>{message}</p>
      </div>
    </div>
  );
};

export default DataNotFound;
